import React, { useState, useRef } from "react";
import styles from "./index.modules.less";
import { cj } from "../../utils/cls";
import SoftInfo from "../../image/info.svg";
import Ellipsis from "../../image/ellipsis.svg"
import { useDispatch, useSelector } from "react-redux";
import TableItem from "./tableItem"

const Table = ({data = {}, tabkey}) => {
  let {list = [], total_num} = data;
  // const {soft} = useSelector((state) => state);
  const dispatch = useDispatch();
  const timerRef = useRef(null);
  console.log("data is", data);
  if (tabkey != 911) {
    list = list.filter((item) => {
      return item.app_status_id == tabkey
    })
  }

  return (
    <div className={styles.normal_list}>
      <div className={cj(styles.l_header)}>
        <div className={styles.l_name}>名称</div>
        <div className={styles.l_type}>类型</div>
        <div className={styles.l_version}>版本</div>
        <div className={styles.l_time}>提交时间</div>
        <div className={styles.l_state}>状态</div>
        <div className={styles.l_state}>备注</div>
        <div className={styles.l_btn}>操作</div>
      </div>
      {
        list?.map((item, index) => (
          <TableItem tabkey={tabkey} key={index} data={item} index={index}></TableItem>
        ))
      }
    </div>
  );
};

export default Table;